import { TutorialTemplate } from "@components/templates";
import { Colors } from "@utils";
import React from "react";
import styled from "styled-components";

import tutorial2Icon from "@assets/images/icon_tutorial_2.png";
import tutorial2Image from "@assets/images/tutorial_2_image.png";
import { Row } from "@components/atoms";
import { HealthPartIcon } from "@utils/Constants";

const Bar = styled.div`
  width: 1px;
  height: 13px;
  background: ${Colors.primaryGreen};
  position: absolute;
  left: 62px;
  top: 88px;
`;

const ContentArea = styled.div`
  border-radius: 10px;
  border: 1px solid ${Colors.primaryGreen};
  background: ${Colors.white};
  padding: 0px 19px;
  margin-left: 38px;
  margin-right: 44px;
  margin-top: 13px;
  height: 51px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ContentAreaShadow = styled.div`
  position: absolute;
  left: 42px;
  right: 40px;
  top: 110px;
  border-radius: 10px;
  border: 1px solid ${Colors.primaryGreen};
  height: 51px;
`;

const Icon = styled.img`
  width: 21px;
  height: 21px;
`;

const HEALTH_PARTS = Object.keys(HealthPartIcon) as HealthPart[];

const Tutorial2Page = () => {
  return (
    <TutorialTemplate page={2}>
      <div className="flex grow flex-col pt-[38px] pb-[32px] relative">
        <Row className="pl-[38px]">
          <img
            src={tutorial2Icon}
            alt=""
            className="w-[50px] h-[50px] mr-[12px]"
          />
          <div>
            <div
              className="text-[14px] font-[700]"
              style={{ color: Colors.totallyBlack }}
            >
              신체 건강 성적
            </div>
            <div
              className="text-[11px] font-[700]"
              style={{ color: Colors.totallyBlack }}
            >
              심장, 췌장, 혈관, 간, 신장, 비만 성적 제공
            </div>
          </div>
        </Row>
        <Bar />
        <ContentAreaShadow />
        <ContentArea style={{ gap: "3%" }}>
          <div
            className="text-[16px] font-[400]"
            style={{ color: Colors.totallyBlack }}
          >
            신체 항목:
          </div>
          {HEALTH_PARTS.map((part) => (
            <Icon key={part} src={HealthPartIcon[part]} />
          ))}
        </ContentArea>
        <div className="grow mt-[43px]" />
        <img
          style={{
            maxHeight: "322px",
            objectFit: "contain",
          }}
          alt=""
          src={tutorial2Image}
        />
      </div>
    </TutorialTemplate>
  );
};

export default Tutorial2Page;
